import TabelaGrupoSede from './components/tabela'
import { Outlet } from 'react-router-dom';

export default function GrupoSede() {

  return (
    <>
      <Outlet/>
      <TabelaGrupoSede />
    </>
  )
}
